import React, { useEffect } from "react";

export interface BNPModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: string; // Optional custom width (defaults to 'max-w-2xl')
  style?: React.CSSProperties; // Optional inline styles
  label?: string; // Accessible dialog label
}

export function BNPModal({
  isOpen,
  onClose,
  children,
  maxWidth = "max-w-2xl",
  style,
  label = "Dialog",
}: BNPModalProps) {
  // Prevent background scrolling when modal is active
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Close on Escape key press
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-spec-ink/60 backdrop-blur-xs transition-opacity animate-in fade-in duration-200">
      {/* Backdrop Click Target */}
      <div className="fixed inset-0" onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={label}
        className={`relative w-full ${maxWidth} bg-white rounded-card shadow-popover overflow-auto transition-all max-h-[90vh] flex flex-col z-10 border border-slate-100`}
        style={style}
      >
        {children}
      </div>
    </div>
  );
}
